<script lang="ts">
	import Search from '@lucide/svelte/icons/search';
	import { cn } from '@ui-lib/utils/utils.js';
	import { Command as CommandPrimitive } from 'bits-ui';

	type Props = CommandPrimitive.InputProps & { outerClass?: string };

	let {
		ref = $bindable(null),
		class: className,
		value = $bindable(''),
		outerClass,
		...restProps
	}: Props = $props();
</script>

<div
	class={cn('flex items-center gap-2 border-b pl-4 pr-0', outerClass)}
	data-command-input-wrapper=""
>
	<Search class="size-4 shrink-0 opacity-50" />
	<CommandPrimitive.Input
		class={cn(
			'placeholder:text-muted-foreground flex h-11 w-full rounded-md bg-transparent py-3 text-base outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
			className
		)}
		bind:ref
		{...restProps}
		bind:value
	/>
</div>
